export const PRIMARY_FONT = "'Open Sans', sans-serif";
export const DISPLAY_FONT = "'Patua One', sans-serif";
export const ICON_FONT_BRANDS = "'Font Awesome\ 5 Brands'";
export const ICON_FONT_FREE = "'Font Awesome\ 5 Free'";
